export const FEATURED_BOOK_HANDLES = [
	"dead-sea-squirrels-1-squirreled-away",
	"dead-sea-squirrels-2-boy-meets-squirrels",
	"dead-sea-squirrels-3-nutty-study-buddies",
	"dead-sea-squirrels-4-squirrelnapped",
	"dead-sea-squirrels-5-treemendous-trouble",
	"dead-sea-squirrels-6-whirly-squirrelies",
];

export const LIVING_BOOK_HANDLES = [
	"the-call-of-the-wild",
	"adventures-of-tom-sawyer",
	"the-red-fairy-book",
	"abc-an-alphabet",
];

export const LIVING_BOOK_AUTHORS: Record<string, string> = {
	"the-call-of-the-wild": "Jack London",
	"adventures-of-tom-sawyer": "Mark Twain",
	"the-red-fairy-book": "Andrew Lang",
	"abc-an-alphabet": "Mrs. Arthur Gaskin",
};

const CURATED_COVER_HANDLES = new Set([
	...FEATURED_BOOK_HANDLES,
	...LIVING_BOOK_HANDLES,
]);

export type CuratedCover = { src: string; srcSet: string };

export function curatedCover(
	handle: string | null | undefined,
): CuratedCover | null {
	if (!handle || !CURATED_COVER_HANDLES.has(handle)) return null;
	const base = `/img/v2/covers/${handle}`;
	return {
		src: `${base}.webp`,
		srcSet: `${base}-360.webp 360w, ${base}.webp 720w`,
	};
}
